export const STORE_ITEM = 'item'
export const STORE_ITEM_NAME = 'itemName'
export const STORE_LIST = 'list'
export const STORE_FILTER_LIST = 'filterList'
export const STORE_WEB_LIST = 'webList'
